import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 根路径根据浏览器语言自动跳转
  {
    path: '/',
    redirect: () => {
      const lang = navigator.language || navigator.userLanguage || 'zh';
      // 中文环境走 home，其他走 main
      return lang.toLowerCase().startsWith('zh') ? '/home' : '/main';
    }
  },
  // ===================== 中文站 =====================
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/cn/HomeView.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      keepAlive: true,
    }
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('../views/cn/common/RecordView.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
    }
  },
  {
    path: '/assessment/:type',
    name: 'assessment',
    component: () => import('../views/cn/common/AssessmentView.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
    }
  },
  // 中文介绍页
  {
    path: '/introduce/:type',
    name: 'introduce',
    component: () => import('../views/cn/common/AssessmentIntroduce.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      selfTitle: true,
    }
  },
  // 中文犬类心理测评
  {
    path: '/dogPsychology',
    name: 'dogPsychology',
    component: () => import('../views/cn/DogPsychology-CN.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      requiresCoupon: true
    }
  },
  // 中文犬类心理测评-记录
  {
    path: '/DogPsychologyRecord/:id',
    name: 'DogPsychologyRecord',
    component: () => import('../views/cn/DogPsychology/DogPsychologyRecord.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
    }
  },
  // 中文猫猫粘人
  {
    path: '/catClingy',
    name: 'catClingy',
    component: () => import('../views/cn/CatClingy/CatClingy.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      requiresCoupon: true
    }
  },
  // 中文猫猫粘人记录
  {
    path: '/CatClingyRecordNew/:id',
    name: 'CatClingyRecordNew',
    component: () => import('../views/cn/CatClingy/CatClingyRecordNew.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
    }
  },
  // 互动类
  {
    path: '/dogInteract/:id?',
    name: 'dogInteract',
    component: () => import('../views/cn/InteractDog/InteractDog.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      requiresCouponWhenNew: true
    }
  },
  // 中文-测评前知情书
  {
    path: '/dogBeforeAssessment/:type',
    name: 'dogBeforeAssessment',
    component: () => import('../views/cn/common/AgreeAssessment.vue'),
    meta: {
      title: 'PokePlanet',
      lang: 'zh',
      requiresCoupon: true
    }
  },
  // 奥德赛时期
  {
      path: '/odyssey/:id?',
      name: 'odyssey',
      component: () => import('../views/cn/Odyssey/OdysseyTest.vue'),
      meta: {
        title: 'PokePlanet',
        lang: 'zh',
        requiresCoupon: true
      }
    },
     {
      path: '/odysseyIntro',
      name: 'odysseyIntro',
      component: () => import('../views/cn/Odyssey/OdysseyIntro.vue'),
      meta: {
        title: 'PokePlanet',
        lang: 'zh',
      }
    },
    
  // ===================== 英文站 =====================
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/en/MainView.vue'),
    meta: {
      title: 'Science-Based Assessments for People & Pets | Yearizon',
      lang: 'en',
      favicon: '/Y.png',
      keepAlive: true
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/en/common/TermsPage.vue'),
    meta: {
      title: 'Terms of Service',
      lang: 'en',
      favicon: '/Y.png',
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/en/common/PrivacyPage.vue'),
    meta: {
      title: 'Privacy Policy',
      lang: 'en',
      favicon: '/Y.png',
    }
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: () => import('../views/en/common/PaymentResult.vue'),
    meta: {
      title: 'Yearizon',
      lang: 'en',
      favicon: '/Y.png',
    }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('../views/en/common/PaymentSuccess.vue'),
    meta: {
      title: 'Yearizon',
      lang: 'en',
      favicon: '/Y.png',
    }
  },
  {
    path: '/payment/failed',
    name: 'PaymentFailed',
    component: () => import('../views/en/common/PaymentFailed.vue'),
    meta: {
      title: 'Yearizon',
      lang: 'en',
      favicon: '/Y.png',
    }
  },
  {
    path: '/en/faq/:tab?',
    name: 'faqEn',
    component: () => import('../views/en/common/FaqView.vue'),
    meta: {
      title: 'Frequently Asked Questions',
      lang: 'en',
      favicon: '/Y.png',
      selfTitle: true,
    }
  },
  // 英文介绍页
  {
    path: '/en/introduce/:type',
    name: 'introduceEn',
    component: () => import('../views/en/common/AssessmentIntroduce.vue'),
    meta: {
      title: 'Assessment',
      lang: 'en',
      favicon: '/Y.png',
      selfTitle: true,
    }
  },
  // 英文犬类行为测评
  {
    path: '/en/dogPsychology',
    name: 'dogPsychologyEn',
    component: () => import('../views/en/DogPsychology-EN.vue'),
    meta: {
      title: 'Canine Behavior & Personality Assessment | Yearizon',
      lang: 'en',
      requiresCoupon: true,
      favicon: '/Y.png'
    }
  },
  // 英文犬类心理测评-记录
  {
    path: '/en/dogPsychologyRecord/:id',
    name: 'DogPsychologyEnRecord',
    component: () => import('../views/en/DogPsychology-EN-record.vue'),
    meta: {
      title: 'Canine Behavior Report | Yearizon',
      lang: 'en',
      favicon: '/Y.png'
    }
  },
  // 英文猫猫粘人
  {
    path: '/en/catClingy',
    name: 'catClingyEn',
    component: () => import('../views/en/CatClingy-EN.vue'),
    meta: {
      title: 'Feline Affection Assessment | Yearizon',
      lang: 'en',
      requiresCoupon: true,
      favicon: '/Y.png'
    }
  },
  // 英文猫猫粘人记录
  {
    path: '/CatClingyRecordEn/:id',
    name: 'CatClingyRecordEn',
    component: () => import('../views/en/CatClingyRecord-EN.vue'),
    meta: {
      title: 'Feline Affection Report | Yearizon',
      lang: 'en',
      favicon: '/Y.png'
    }
  },
  // 朋友圈定位
  {
    path: '/en/friendshipType',
    name: 'friendshipTypeEn',
    component: () => import('../views/en/FriendshipType.vue'),
    meta: {
      title: 'Friend Group Role Test | Yearizon',
      lang: 'en',
      requiresCoupon: true,
      favicon: '/Y.png'
    }
  },
  // 朋友圈定位-记录
  {
    path: '/en/friendshipTypeRecord/:id',
    name: 'FriendshipEnRecord',
    component: () => import('../views/en/FriendshipType-record.vue'),
    meta: {
      title: 'Friend Group Role Report | Yearizon',
      lang: 'en',
      requiresCoupon: false,
      favicon: '/Y.png'
    }
  },
  // 英文-测评前知情书
  {
    path: '/en/AgreeAssessment/:type',
    name: 'dogBeforeAssessmentEn',
    component: () => import('../views/en/common/AgreeAssessment.vue'),
    meta: {
      title: 'Informed Consent | Yearizon',
      lang: 'en',
      requiresCoupon: true,
      favicon: '/Y.png'
    }
  },

  // ===================== 后台 =====================
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/common/AdminView.vue'),
    meta: {
      title: '后台管理',
      lang: 'zh'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// ===== 动态切换 favicon =====
function setFavicon(url) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
}

// 路由守卫 - 兑换码验证 + 标题
// 路由守卫 - 兑换码验证 + 标题
router.beforeEach(async (to, from, next) => {
  // ===== 设置 favicon =====
  setFavicon(to.meta.favicon || '/favicon.ico');

  // ===== 设置页面标题 =====
  const isEnglishSite = to.meta.lang === 'en';
  const brandName = isEnglishSite ? 'Yearizon' : 'PokePlanet';

  if (to.meta.title && !to.meta.selfTitle) {
    document.title = `${to.meta.title} | ${brandName}`;
  }

  // ===== 关键判断：dogInteract 有 id 时，跳过兑换码验证 =====
  const isDogInteractWithId =
    to.name === 'dogInteract' && to.params.id

  if (isDogInteractWithId) {
    next()
    return
  }

  // ===== 检查是否需要兑换码 =====
  if (to.meta.requiresCoupon || to.meta.requiresCouponWhenNew) {
    // 从 localStorage 获取兑换码信息
    const couponCode = localStorage.getItem('couponCode')
    const couponType = localStorage.getItem('couponType')
    const couponData = localStorage.getItem('couponData')

    // 检查是否有兑换码信息
    if (couponCode && couponType && couponData) {
      try {
        // 判断是否在生产环境
        let apiPrefix = ""
        if (
          window.location.hostname.includes("pokeplanet") ||
          window.location.hostname.includes("47.83.221.39")
        ) {
          apiPrefix = "" // 生产环境使用相对路径
        } else {
          apiPrefix = "http://localhost:3000" // 开发环境使用本地API
        }

        // 调用后端验证接口验证兑换码有效性
        const response = await fetch(`${apiPrefix}/api/coupons/validate`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code: couponCode,
            couponType: couponType
          })
        })

        if (response.ok) {
          const data = await response.json()
          if (data.success && data.data.valid) {
            // 兑换码有效，允许访问
            next()
            return
          } else {
            // 兑换码无效，清除本地数据
            clearCouponData()
            
            // ==========================================
            // 【改动 1】：兑换码无效时
            // ==========================================
            if (to.name === 'odyssey') {
              next({ name: 'odysseyIntro', query: { error: '兑换码无效' } })
            } else {
              redirectToIntroducePage(to, next, 'invalidCode')
            }
            return
          }
        } else {
          // 网络请求失败，保守策略：要求重新验证
          clearCouponData()
          
          // ==========================================
          // 【改动 2】：网络请求失败时
          // ==========================================
          if (to.name === 'odyssey') {
            next({ name: 'odysseyIntro', query: { error: '网络请求错误，请稍后重试' } })
          } else {
            redirectToIntroducePage(to, next, 'verifyFailed')
          }
          return
        }

      } catch (error) {
        console.error('验证兑换码失败:', error)
        clearCouponData()
        
        // ==========================================
        // 【改动 3】：验证接口报错（catch）时
        // ==========================================
        if (to.name === 'odyssey') {
          next({ name: 'odysseyIntro', query: { error: '验证失败，请检查网络连接' } })
        } else {
          redirectToIntroducePage(to, next, 'networkError')
        }
        return
      }
    }

    // ==========================================
    // 【改动 4】：本地完全没有兑换码时
    // ==========================================
    if (to.name === 'odyssey') {
      next({ name: 'odysseyIntro', query: { error: '请先输入有效的兑换码' } })
    } else {
      redirectToIntroducePage(to, next, 'noCode')
    }

  } else {
    // 不需要兑换码的路由直接放行
    next()
  }
})

// 添加全局路由守卫，每次路由跳转都回到顶部
router.afterEach((to) => {
  // 如果目标页面是首页（带 keepAlive），不强制滚动，让 keep-alive 恢复原来的位置
  if (to.meta?.keepAlive) {
    return;
  }
  document.querySelector(".assessment-container")?.scrollIntoView();
  document.querySelector(".pet-assessment-form")?.scrollIntoView();
  document.querySelector(".assessment-detail")?.scrollIntoView();
})

// 清除兑换码数据
function clearCouponData() {
  localStorage.removeItem('couponCode')
  localStorage.removeItem('couponType')
  localStorage.removeItem('couponData')
}

// 跳转到介绍页
function redirectToIntroducePage(to, next, messageKey) {
  // 优先用 meta.lang 判断中英文站
  const isEnSite = to.meta.lang === 'en';

  // 决定跳哪个介绍页
  const introduceRouteName = isEnSite ? 'introduceEn' : 'introduce';

  // 提示语翻译（根据站点语言自动切换）
  const messages = {
    invalidCode: isEnSite
      ? 'Invalid access code.'
      : '兑换码无效',
    verifyFailed: isEnSite
      ? 'Verification failed. Please enter your access code again.'
      : '验证失败，请重新输入兑换码',
    networkError: isEnSite
      ? 'Verification failed. Please check your network connection.'
      : '验证失败，请检查网络连接',
    noCode: isEnSite
      ? 'Please enter a valid access code first.'
      : '请先输入有效的兑换码',
  };
  const message = messages[messageKey] || messageKey;

  // 决定 type 参数
  let typeParam;

  if (to.name === "dogBeforeAssessment" || to.name === "dogBeforeAssessmentEn") {
    // 从知情书页跳回来，保留原来的 type
    typeParam = to.params.type;
  } else if (isEnSite) {
    // 英文路由：把路由名映射成英文介绍页需要的 category
    const enTypeMap = {
      'dogPsychologyEn': 'dogPsychologyEn',
      'catClingyEn': 'catClingyEn',
      'friendshipTypeEn': 'friendshipTypeEn',
    };
    typeParam = enTypeMap[to.name] || to.name;
  } else {
    // 中文路由
    const cnTypeMap = {
      'dogPsychology': 'dogPsychology',
      'catClingy': 'catClingy',
      'dogInteract': 'dogInteract',
    };
    typeParam = cnTypeMap[to.name] || to.name;
  }

  next({
    name: introduceRouteName,
    params: { type: typeParam },
    query: {
      redirect: to.fullPath,
      error: message
    }
  });
}

export default router